import React from "react";

const TermsAndConditions = () => {
  return (
    <div className="policy-container max-w-4xl mx-auto py-12 px-4 md:px-8">
      <h1 className="text-4xl font-bold text-gray-900 mb-8 text-center">Terms & Conditions</h1>
      <p className="text-lg text-gray-700 mb-8 leading-relaxed">
        Welcome to <strong>Cycle Services</strong>. By purchasing bicycles, parts, accessories, or services, 
        you agree to these terms ensuring safe, transparent transactions.
      </p>

      <h2 className="text-2xl font-semibold text-gray-900 mb-4">1. Orders & Payments</h2>
      <ul className="list-disc list-inside text-lg text-gray-700 mb-6 space-y-2">
        <li>Full payment required at order (online or COD where available).</li>
        <li>Accepted: Razorpay/PhonePe/UPI, Cash on Delivery (pincode-checked).</li>
        <li>Confirmed orders non-cancellable except per Refund Policy.</li>
      </ul>

      <h2 className="text-2xl font-semibold text-gray-900 mb-4">2. Shipping & Delivery</h2>
      <p className="text-lg text-gray-700 mb-4 leading-relaxed">See <a href="/shipping-and-delivery" className="text-blue-600 hover:underline">Shipping Policy</a>.</p>
      <ul className="list-disc list-inside text-lg text-gray-700 mb-6 space-y-2">
        <li>Customer-selected delivery dates confirmed at checkout.</li>
        <li>Local pickup available (free in Mumbai).</li>
      </ul>

      <h2 className="text-2xl font-semibold text-gray-900 mb-4">3. Returns & Refunds</h2>
      <p className="text-lg text-gray-700 mb-4 leading-relaxed">See <a href="/refund-policy" className="text-blue-600 hover:underline">Refund Policy</a>.</p>
      <ul className="list-disc list-inside text-lg text-gray-700 mb-6 space-y-2">
        <li>No returns on ridden/tested cycles/parts (safety/hygiene).</li>
        <li>Defective/wrong item returns within 7 days with photos.</li>
      </ul>

      <h2 className="text-2xl font-semibold text-gray-900 mb-4">4. Product Usage & Maintenance</h2>
      <ul className="list-disc list-inside text-lg text-gray-700 mb-6 space-y-2">
        <li>Follow provided assembly/maintenance guides.</li>
        <li>cycles delivered partially assembled; professional assembly recommended.</li>
        <li>No liability for damage from misuse, improper maintenance, or unauthorized modifications.</li>
        <li>Warranty voided by test rides before full assembly/inspection.</li>
      </ul>

      <h2 className="text-2xl font-semibold text-gray-900 mb-4">5. Services (Rentals/Repairs)</h2>
      <ul className="list-disc list-inside text-lg text-gray-700 mb-6 space-y-2">
        <li>Rentals: Helmets/lights mandatory; damage fees apply.</li>
        <li>Repairs: 30-day warranty on workmanship (parts separate).</li>
        <li>Service appointments confirmed via SMS/email.</li>
      </ul>

      <h2 className="text-2xl font-semibold text-gray-900 mb-4">6. Intellectual Property</h2>
      <p className="text-lg text-gray-700 mb-6 leading-relaxed">
        All cycle designs, images, branding, and content property of Cycle Services. No reproduction without permission.
      </p>

      <h2 className="text-2xl font-semibold text-gray-900 mb-4">7. Policy Updates</h2>
      <p className="text-lg text-gray-700 mb-6 leading-relaxed">
        We may update terms; changes posted here. Continued use implies acceptance.
      </p>

      <h2 className="text-2xl font-semibold text-gray-900 mb-4">8. Limitation of Liability</h2>
      <p className="text-lg text-gray-700 mb-6 leading-relaxed">
        Not liable for indirect damages, injuries from misuse, or third-party courier issues.
      </p>

      <h2 className="text-2xl font-semibold text-gray-900 mb-4">9. Contact Us</h2>
      <p className="text-lg text-gray-700 mb-4 leading-relaxed">For questions:</p>
      <ul className="list-disc list-inside text-lg text-gray-700 space-y-2">
        <li><strong>Phone:</strong> 1234567891</li>
        <li><strong>Email:</strong> cyclerental@gmail.com</li>
        <li><strong>Address:</strong> Mumbai, MH - 400101, India</li>
      </ul>
    </div>
  );
};

export default TermsAndConditions;

